<template>
  <div class="global-wrapper">
    <div class="donation-detail">
      <div class="main-content bg-white" style="padding: 15px; padding-bottom: 30px;">
        <div class="wrapper-form">
          <div class="row">
            <div class="col-12" style="text-align:center">
              <h4>Form Pendaftaran Lembaga</h4>
            </div>
          </div>
          <SizedBox :height="35" />
          <form @submit.prevent="handleRegister">
            <!-- INFORfSI PENGURUS -->
            <h3>Informasi PIC</h3>
            <SizedBox :height="60" />
            <div class="form-group">
              <label for="fullname"><strong>Nama Lengkap</strong></label>
              <input
                v-model="fullname"
                type="text"
                class="form-control"
                placeholder="Nama Lengkap Anda"
                name="fullname"
              />
              <div class="error" v-if="$v.fullname.$dirty && !$v.fullname.required">
                Nama Lengkap wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="email"><strong>Email</strong></label>
              <input v-model="email" type="text" class="form-control" placeholder="Email Anda" name="email" />
              <div class="error" v-if="$v.email.$dirty && !$v.email.required">
                Email wajib diisi.
              </div>
              <div class="error" v-if="$v.email.$dirty && !$v.email.email">
                Format email anda salah.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="no_telp"><strong>Nomor Telepon / HP</strong></label>
              <input
                v-model="no_telp"
                type="text"
                class="form-control"
                placeholder="Nomor Telepon / HP Anda"
                name="no_telp"
                v-number-only
              />
              <div class="error" v-if="$v.no_telp.$dirty && !$v.no_telp.required">
                Nomor telepon wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="nik"><strong>NIK ( Nomor Induk KTP )</strong></label>
              <input v-model="nik" type="text" class="form-control" placeholder="NIK Anda" name="nik" v-number-only />

              <div class="error" v-if="$v.nik.$dirty && !$v.nik.required">
                NIK wajib diisi.
              </div>
            </div>

            <!-- INFORMASI UMUM -->
            <SizedBox :height="50" />
            <h3>Informasi Umum Lembaga</h3>
            <SizedBox :height="60" />

            <div class="form-group">
              <label for="lembaga_name"><strong>Nama Lembaga</strong></label>
              <input
                v-model="lembaga_name"
                type="text"
                class="form-control"
                placeholder="Nama Lembaga"
                name="lembaga_name"
              />
              <div class="error" v-if="$v.lembaga_name.$dirty && !$v.lembaga_name.required">
                Nama Masjed wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="lembaga_address">
                <strong>Alamat Lembaga </strong>
                <button type="button" class="btn btn-titik-jemput" @click="modalMap()">
                  Set Titik
                </button>
              </label>
              <textarea
                v-model="lembaga_address"
                type="text"
                class="form-control"
                placeholder="Alamat Lembaga"
                name="lembaga_address"
              ></textarea>
              <span style="font-size: 11px">
                titik koordinat, latitude: <strong>{{ center.lat }}</strong
                >, longitude:
                <strong>{{ center.lng }}</strong>
              </span>

              <div class="error" v-if="$v.lembaga_address.$dirty && !$v.lembaga_address.required">
                Alamat Lembaga wajib diisi.
              </div>
            </div>

            <SizedBox :height="15" />

            <div class="form-group">
              <label for="lembaga_capacity"><strong>Kapasitas Penyaluran</strong></label>
              <input
                v-model="lembaga_capacity"
                type="text"
                class="form-control"
                placeholder="Kapasitas Penyaluran"
                name="lembaga_capacity"
                v-number-only
              />
              <div class="error" v-if="$v.lembaga_capacity.$dirty && !$v.lembaga_capacity.required">
                Kapasitas Penyaluran wajib diisi.
              </div>
            </div>

            <SizedBox :height="35" />

            <div class="form-group">
              <button type="submit" class="btn btn-cta btn-full" :disabled="isSubmit">
                Daftar
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Map -->
      <modal class="map-wrapper" name="map-wrapper">
        <div class="map-title">
          <h5 class="text-center">Titik Masjed</h5>
        </div>
        <div class="map-body">
          <div class="map-search">
            <div class="search-wrapper">
              <GmapAutocomplete @place_changed="setPlace" class="form-control" :options="{ fields: ['geometry'] }" />
              <img src="/img/icon-search.png" class="icon-search" />
            </div>
          </div>
          <gmap-map :center="center" :zoom="zoom" style="width: 100%; height: 400px" :options="mapOptions">
            <gmap-marker
              :position="center"
              @click="center = center"
              :draggable="true"
              @drag="updateCoordinates"
            ></gmap-marker>
          </gmap-map>
          <div class="current-location" @click="geolocate">
            <font-awesome-icon icon="crosshairs" />
          </div>
        </div>
        <SizedBox :height="15" />
        <div class="map-footer">
          <a href="javascript:void(0)" class="btn btn-cta btn-full" @click="saveCoordinates">Simpan</a>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import SizedBox from "../../components/SizedBox.vue";
import { required, email } from "vuelidate/lib/validators";
import axios from "../../utils/masjidiapi";

export default {
  name: "donation-detail",
  components: {
    SizedBox,
  },
  data() {
    return {
      isSubmit: false,

      fullname: "",
      email: "",
      no_telp: "",

      nik: "",
      nik_url: null,
      nik_file: null,

      masjed_foto_url: null,
      masjed_foto_file: null,

      jenispln: "",
      nometerpln: "",

      bank_pemilik: "",
      bank_norek: "",
      bank_id: "",

      lembaga_name: "",
      lembaga_capacity: "",
      lembaga_address: "",

      bank: [],

      // maps
      center: { lat: 45.508, lng: -73.587 },
      zoom: 17,
      markers: [],
      currentPlace: null,
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true,
      },
    };
  },
  validations: {
    fullname: {
      required,
    },
    email: {
      required,
      email,
    },
    no_telp: {
      required,
    },
    nik: {
      required,
    },
    lembaga_name: {
      required,
    },
    lembaga_capacity: {
      required,
    },
    lembaga_address: {
      required,
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.geolocate();
    this.loadBank();
  },
  methods: {
    async loadBank() {
      const bank = await axios.get(`/api-register-masjed-aja/get-bank`);
      const { data } = bank.data;
      this.bank = data;
    },
    async handleRegister() {
      this.$v.$touch();

      this.isSubmit = true;

      const formData = new FormData();

      formData.append("fullname", this.fullname);
      formData.append("email", this.email);
      formData.append("no_telp", this.no_telp);
      formData.append("nik", this.nik);
      formData.append("lat", this.center.lat);
      formData.append("lng", this.center.lng);
      formData.append("lembaga_name", this.lembaga_name);
      formData.append("lembaga_capacity", this.lembaga_capacity);
      formData.append("lembaga_address", this.lembaga_address);

      if (this.$v.$invalid) {
        this.isSubmit = false;
      } else {
        try {
          const daftarMasjed = await axios.post(`/api-register-lembaga/save`, formData);

          const { data } = daftarMasjed.data;

          if (data.hasOwnProperty("exists")) {
            if (parseInt(data.exists) > 0) {
              const m = daftarMasjed.data;
              this.$toasted.show(m.meta.message, {
                type: "error",
                position: "bottom-center",
                duration: 3000,
                class: "toasting",
              });

              this.isSubmit = false;
              return false;
            }
          }

          this.$router.push({ name: "success-page" });
        } catch (error) {
          this.isSubmit = false;
          console.log(error.error);
          this.$toasted.show("Terjadi kesalahan server.", {
            type: "error",
            position: "bottom-center",
            duration: 3000,
            class: "toasting",
          });
        }
      }
      this.isSubmit = false;
    },
    modalMap() {
      this.$modal.show("map-wrapper");
    },
    setPlace(place) {
      this.center = place.geometry.location;
    },
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    updateCoordinates(location) {
      this.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    saveCoordinates() {
      this.$modal.hide("map-wrapper");
      this.$toasted.show("Titik berhasil diset.", {
        type: "success",
        position: "bottom-center",
        duration: 3000,
      });
    },
    onKTPChange(e) {
      const file = e.target.files[0];
      this.nik_url = URL.createObjectURL(file);
      this.nik_file = file;
    },
    onMasjedChange(e) {
      const file = e.target.files[0];
      this.masjed_foto_url = URL.createObjectURL(file);
      this.masjed_foto_file = file;
    },
  },
  directives: {
    numberOnly: {
      bind: function(el) {
        el.handler = function() {
          el.value = el.value.replace(/\D+/, "");
        };
        el.addEventListener("input", el.handler);
      },
      unbind: function(el) {
        el.removeEventListener("input", el.handler);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/donation-detail";

.wrapper-form {
  position: relative;
  h3 {
    position: absolute;
    font-size: 17px;
    margin: 0px;
    left: -15px;
    background: transparent linear-gradient(180deg, #28a745 0%, #145423 100%) 0% 0% no-repeat padding-box;
    padding: 5px 40px 5px 10px;
    color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}

.error {
  font-size: 11px;
  color: rgb(255, 13, 13);
}

::placeholder {
  color: #cccccc !important;
  opacity: 1; /* Firefox */
  font-size: 12px;
}
</style>
